import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const HullClaim = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="HullClaim" />
                    <HerosectionsAll ScreenName="Hull & Machinery Claims" ScreenSearch="hull" />

                    <div className="row col-lg-11 mx-auto p-2 p-lg-5 my-5 ">
                        <div className="col-12 p-lg-5 faint p-4" style={{ textAlign: 'justify', }}>
                            <h5 className="fw-bold gray_color pb-3">Hull & Machinery Claims</h5>

                            <p>Claim on Hull & Machinery policy can be reported in one or more heads mentioned in the following diagram. Each claim is unique in respect to its circumstances and governed by the clauses enclosed to the policy schedule. Physical Loss or Damage claims can be further bifurcated into Actual Total Loss (ATL), Constructive Total Loss (CTL), Claim for unrepaired damages and partial losses.  </p>


                            <div className="bg-white mt-5">
                                <img src="Static/Assets/Img/services/HULL & MACHINERY CLAIMS-01.png" alt="" className="Hull_claims_img" />
                            </div>

                            <p className="pt-5">We provide claim management Services and assistance in handling these various types of claims and claim related communications with the various parties involved. We also provide legal review whenever required and also give our opinion of the probable recoveries from the Third Parties. We also provide the services in cost analysis towards the invoices and estimates submitted in support of the claims. </p>

                        </div>

                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
